import { render, staticRenderFns } from "./HistoryConversationList.vue?vue&type=template&id=57fe4896&scoped=true"
import script from "./HistoryConversationList.vue?vue&type=script&lang=js"
export * from "./HistoryConversationList.vue?vue&type=script&lang=js"
import style0 from "./HistoryConversationList.vue?vue&type=style&index=0&id=57fe4896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fe4896",
  null
  
)

export default component.exports